import { AxiosInstance, AxiosResponse } from "axios";
import GOVRequester from "./GOV.requester";
import { GOVCompany } from "./GOV.type";

export class GOVService {
    static instance: AxiosInstance = GOVRequester.create();

    static getCompany(cnpj: string): Promise<AxiosResponse<GOVCompany>> {
        return GOVService.instance.get<GOVCompany>(`consulta-cnpj-df/v2/empresa/${cnpj}`);
    }
}

export default GOVService;
